import { render } from "./BrandCreateComponent.vue?vue&type=template&id=6c5b04f8"
import script from "./BrandCreateComponent.vue?vue&type=script&lang=js"
export * from "./BrandCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__